function time2TimeAgo(time) {
  let d = new Date();
  let currentTime = Math.floor(d.getTime() / 1000);
  let seconds = currentTime - time;

  // more that two days
  if (seconds > 2 * 24 * 3600) {
    return "a few days ago";
  }
  // a day
  if (seconds > 24 * 3600) {
    return "Yesterday";
  }

  if (seconds > 3600) {
    return Math.floor(seconds / 3600) + " hours ago";
  }
  if (seconds > 60) {
    return Math.floor(seconds / 60) + " minutes ago";
  }
}

export default time2TimeAgo;
